import I18n from 'i18n-js'
import { isEmail, isEmpty } from './validator'

const ForgotPasswordValidator = (email) => {
  const error = {}
  error.email = isEmpty(email)
  if (!error.email) {
    error.isemail = isEmail(email)
    error.isemail
      ? (error.emailLeyend = I18n.t('validators.invalidEmail'))
      : (error.emailLeyend = '')
  }
  return error
}

export default ForgotPasswordValidator
